import Dialog from '@zenbusiness/zui/Dialog';
import IconButton from '@zenbusiness/zui/IconButton';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  tag: Dialog,
  name: 'ComparePackagesModal',
  slot: 'Root',
  styles: ({ theme }) => ({
    '& .MuiDialog-container ': {
      '&>.MuiPaper-root': {
        maxWidth: '37.5rem',
        borderRadius: theme.shape.rounded.xl,

        [theme.breakpoints.up('lg')]: {
          maxWidth: '75rem',
        },
      },
    },
  }),
});

export const Container = superstyled({
  tag: Stack,
  name: 'ComparePackagesModal',
  slot: 'Container',
  styles: ({ theme }) => ({
    padding: theme.spacing(3, 2),

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(4),
    },
  }),
});

export const Content = superstyled({
  tag: Stack,
  name: 'ComparePackagesModal',
  slot: 'Content',
  styles: ({ theme }) => ({
    flexDirection: 'column',
    gap: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      gap: theme.spacing(1.5),
    },
  }),
});

export const CloseButton = superstyled({
  tag: IconButton,
  name: 'ComparePackagesModal',
  slot: 'CloseButton',
  styles: ({ theme }) => ({
    position: 'absolute',
    right: '1.5rem',
    top: '1.5rem',
    padding: theme.spacing(0),
    width: '2rem',
    height: '2rem',
  }),
});
